import Vue from 'vue';
import App from './App.vue';
import router from './router';
import VueSignaturePad from "vue-signature-pad";
import Loading from "vue-loading-overlay";
import Notifications from "vue-notification";

// Import Bootstrap and BootstrapVue CSS files
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import "vue-loading-overlay/dist/vue-loading.css";

// Import BootstrapVue
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';

import './utils/component'

import './assets/css/common.css'
// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(Loading);
Vue.use(VueSignaturePad);
Vue.use(Notifications);

Vue.config.productionTip = false;

new Vue({
  router, 
  render: (h) => h(App),
}).$mount('#app');
